// --- BEGIN AUTO-GENERATED FILE ---
//
// @IconsVersion: 1.0.0-alpha2
// @Generated: 2020-03-05T06:55:00.729Z
//
// This file is generated on each build. Do not edit this file!

import { pluginFactoryNoConfig } from '../utils/plugins'

// Icon helper component
import { BIcon } from './icon'

// Icon stacking component
import { BIconstack } from './iconstack'

import {
  // BootstrapVue custom icons
  BIconBlank,
  // Bootstrap icons
  BIconAlarm,
  BIconAlarmFill,
  BIconAlertCircle,
  BIconAlertCircleFill,
  BIconAlertOctagon,
  BIconAlertOctagonFill,
  BIconAlertSquare,
  BIconAlertSquareFill,
  BIconAlertTriangle,
  BIconAlertTriangleFill,
  BIconArchive,
  BIconArchiveFill,
  BIconArrowBarBottom,
  BIconArrowBarLeft,
  BIconArrowBarRight,
  BIconArrowBarUp,
  BIconArrowClockwise,
  BIconArrowCounterclockwise,
  BIconArrowDown,
  BIconArrowDownLeft,
  BIconArrowDownRight,
  BIconArrowDownShort,
  BIconArrowLeft,
  BIconArrowLeftRight,
  BIconArrowLeftShort,
  BIconArrowRepeat,
  BIconArrowRight,
  BIconArrowRightShort,
  BIconArrowUp,
  BIconArrowUpDown,
  BIconArrowUpLeft,
  BIconArrowUpRight,
  BIconArrowUpShort,
  BIconArrowsAngleContract,
  BIconArrowsAngleExpand,
  BIconArrowsCollapse,
  BIconArrowsExpand,
  BIconArrowsFullscreen,
  BIconAt,
  BIconAward,
  BIconBackspace,
  BIconBackspaceFill,
  BIconBackspaceReverse,
  BIconBackspaceReverseFill,
  BIconBarChart,
  BIconBarChartFill,
  BIconBattery,
  BIconBatteryCharging,
  BIconBatteryFull,
  BIconBell,
  BIconBellFill,
  BIconBlockquoteLeft,
  BIconBlockquoteRight,
  BIconBook,
  BIconBookHalfFill,
  BIconBookmark,
  BIconBookmarkFill,
  BIconBootstrap,
  BIconBootstrapFill,
  BIconBootstrapReboot,
  BIconBoxArrowBottomLeft,
  BIconBoxArrowBottomRight,
  BIconBoxArrowDown,
  BIconBoxArrowLeft,
  BIconBoxArrowRight,
  BIconBoxArrowUp,
  BIconBoxArrowUpLeft,
  BIconBoxArrowUpRight,
  BIconBraces,
  BIconBrightnessFillHigh,
  BIconBrightnessFillLow,
  BIconBrightnessHigh,
  BIconBrightnessLow,
  BIconBrush,
  BIconBucket,
  BIconBucketFill,
  BIconBuilding,
  BIconBullseye,
  BIconCalendar,
  BIconCalendarFill,
  BIconCamera,
  BIconCameraVideo,
  BIconCameraVideoFill,
  BIconCapslock,
  BIconCapslockFill,
  BIconChat,
  BIconChatFill,
  BIconCheck,
  BIconCheckBox,
  BIconCheckCircle,
  BIconChevronCompactDown,
  BIconChevronCompactLeft,
  BIconChevronCompactRight,
  BIconChevronCompactUp,
  BIconChevronDown,
  BIconChevronLeft,
  BIconChevronRight,
  BIconChevronUp,
  BIconCircle,
  BIconCircleFill,
  BIconCircleHalf,
  BIconCircleSlash,
  BIconClock,
  BIconClockFill,
  BIconCloud,
  BIconCloudDownload,
  BIconCloudFill,
  BIconCloudUpload,
  BIconCode,
  BIconCodeSlash,
  BIconColumns,
  BIconColumnsGutters,
  BIconCommand,
  BIconCompass,
  BIconCone,
  BIconConeStriped,
  BIconController,
  BIconCreditCard,
  BIconCursor,
  BIconCursorFill,
  BIconDash,
  BIconDiamond,
  BIconDiamondHalf,
  BIconDisplay,
  BIconDisplayFill,
  BIconDocument,
  BIconDocumentCode,
  BIconDocumentDiff,
  BIconDocumentRichtext,
  BIconDocumentSpreadsheet,
  BIconDocumentText,
  BIconDocuments,
  BIconDocumentsAlt,
  BIconDot,
  BIconDownload,
  BIconEggFried,
  BIconEject,
  BIconEjectFill,
  BIconEnvelope,
  BIconEnvelopeFill,
  BIconEnvelopeOpen,
  BIconEnvelopeOpenFill,
  BIconEye,
  BIconEyeFill,
  BIconEyeSlash,
  BIconEyeSlashFill,
  BIconFilter,
  BIconFlag,
  BIconFlagFill,
  BIconFolder,
  BIconFolderFill,
  BIconFolderSymlink,
  BIconFolderSymlinkFill,
  BIconFonts,
  BIconForward,
  BIconForwardFill,
  BIconGear,
  BIconGearFill,
  BIconGearWide,
  BIconGearWideConnected,
  BIconGeo,
  BIconGraphDown,
  BIconGraphUp,
  BIconGrid,
  BIconGridFill,
  BIconHammer,
  BIconHash,
  BIconHeart,
  BIconHeartFill,
  BIconHouse,
  BIconHouseFill,
  BIconImage,
  BIconImageAlt,
  BIconImageFill,
  BIconImages,
  BIconInbox,
  BIconInboxFill,
  BIconInboxes,
  BIconInboxesFill,
  BIconInfo,
  BIconInfoFill,
  BIconInfoSquare,
  BIconInfoSquareFill,
  BIconJustify,
  BIconJustifyLeft,
  BIconJustifyRight,
  BIconKanban,
  BIconKanbanFill,
  BIconLaptop,
  BIconLayoutSidebar,
  BIconLayoutSidebarReverse,
  BIconLayoutSplit,
  BIconList,
  BIconListCheck,
  BIconListOl,
  BIconListTask,
  BIconListUl,
  BIconLock,
  BIconLockFill,
  BIconMap,
  BIconMic,
  BIconMoon,
  BIconMusicPlayer,
  BIconMusicPlayerFill,
  BIconOption,
  BIconOutlet,
  BIconPause,
  BIconPauseFill,
  BIconPen,
  BIconPencil,
  BIconPeople,
  BIconPeopleFill,
  BIconPerson,
  BIconPersonFill,
  BIconPhone,
  BIconPhoneLandscape,
  BIconPieChart,
  BIconPieChartFill,
  BIconPlay,
  BIconPlayFill,
  BIconPlug,
  BIconPlus,
  BIconPower,
  BIconQuestion,
  BIconQuestionFill,
  BIconQuestionSquare,
  BIconQuestionSquareFill,
  BIconReply,
  BIconReplyAll,
  BIconReplyAllFill,
  BIconReplyFill,
  BIconScrewdriver,
  BIconSearch,
  BIconShield,
  BIconShieldFill,
  BIconShieldLock,
  BIconShieldLockFill,
  BIconShieldShaded,
  BIconShift,
  BIconShiftFill,
  BIconSkipBackward,
  BIconSkipBackwardFill,
  BIconSkipEnd,
  BIconSkipEndFill,
  BIconSkipForward,
  BIconSkipForwardFill,
  BIconSkipStart,
  BIconSkipStartFill,
  BIconSpeaker,
  BIconSquare,
  BIconSquareFill,
  BIconSquareHalf,
  BIconStar,
  BIconStarFill,
  BIconStarHalf,
  BIconStop,
  BIconStopFill,
  BIconStopwatch,
  BIconStopwatchFill,
  BIconSun,
  BIconTable,
  BIconTablet,
  BIconTabletLandscape,
  BIconTag,
  BIconTagFill,
  BIconTerminal,
  BIconTerminalFill,
  BIconTextCenter,
  BIconTextIndentLeft,
  BIconTextIndentRight,
  BIconTextLeft,
  BIconTextRight,
  BIconThreeDots,
  BIconThreeDotsVertical,
  BIconToggleOff,
  BIconToggleOn,
  BIconToggles,
  BIconTools,
  BIconTrash,
  BIconTrashFill,
  BIconTriangle,
  BIconTriangleFill,
  BIconTriangleHalf,
  BIconTrophy,
  BIconTv,
  BIconTvFill,
  BIconType,
  BIconTypeBold,
  BIconTypeH1,
  BIconTypeH2,
  BIconTypeH3,
  BIconTypeItalic,
  BIconTypeStrikethrough,
  BIconTypeUnderline,
  BIconUnlock,
  BIconUnlockFill,
  BIconUpload,
  BIconVolumeDown,
  BIconVolumeDownFill,
  BIconVolumeMute,
  BIconVolumeMuteFill,
  BIconVolumeUp,
  BIconVolumeUpFill,
  BIconWallet,
  BIconWatch,
  BIconWifi,
  BIconWindow,
  BIconWrench,
  BIconX,
  BIconXCircle,
  BIconXCircleFill,
  BIconXOctagon,
  BIconXOctagonFill,
  BIconXSquare,
  BIconXSquareFill
} from './icons'

// Icon component names for used in the docs
export const iconNames = [
  // BootstrapVue custom icon component names
  'BIconBlank',
  // Bootstrap icon component names
  'BIconAlarm',
  'BIconAlarmFill',
  'BIconAlertCircle',
  'BIconAlertCircleFill',
  'BIconAlertOctagon',
  'BIconAlertOctagonFill',
  'BIconAlertSquare',
  'BIconAlertSquareFill',
  'BIconAlertTriangle',
  'BIconAlertTriangleFill',
  'BIconArchive',
  'BIconArchiveFill',
  'BIconArrowBarBottom',
  'BIconArrowBarLeft',
  'BIconArrowBarRight',
  'BIconArrowBarUp',
  'BIconArrowClockwise',
  'BIconArrowCounterclockwise',
  'BIconArrowDown',
  'BIconArrowDownLeft',
  'BIconArrowDownRight',
  'BIconArrowDownShort',
  'BIconArrowLeft',
  'BIconArrowLeftRight',
  'BIconArrowLeftShort',
  'BIconArrowRepeat',
  'BIconArrowRight',
  'BIconArrowRightShort',
  'BIconArrowUp',
  'BIconArrowUpDown',
  'BIconArrowUpLeft',
  'BIconArrowUpRight',
  'BIconArrowUpShort',
  'BIconArrowsAngleContract',
  'BIconArrowsAngleExpand',
  'BIconArrowsCollapse',
  'BIconArrowsExpand',
  'BIconArrowsFullscreen',
  'BIconAt',
  'BIconAward',
  'BIconBackspace',
  'BIconBackspaceFill',
  'BIconBackspaceReverse',
  'BIconBackspaceReverseFill',
  'BIconBarChart',
  'BIconBarChartFill',
  'BIconBattery',
  'BIconBatteryCharging',
  'BIconBatteryFull',
  'BIconBell',
  'BIconBellFill',
  'BIconBlockquoteLeft',
  'BIconBlockquoteRight',
  'BIconBook',
  'BIconBookHalfFill',
  'BIconBookmark',
  'BIconBookmarkFill',
  'BIconBootstrap',
  'BIconBootstrapFill',
  'BIconBootstrapReboot',
  'BIconBoxArrowBottomLeft',
  'BIconBoxArrowBottomRight',
  'BIconBoxArrowDown',
  'BIconBoxArrowLeft',
  'BIconBoxArrowRight',
  'BIconBoxArrowUp',
  'BIconBoxArrowUpLeft',
  'BIconBoxArrowUpRight',
  'BIconBraces',
  'BIconBrightnessFillHigh',
  'BIconBrightnessFillLow',
  'BIconBrightnessHigh',
  'BIconBrightnessLow',
  'BIconBrush',
  'BIconBucket',
  'BIconBucketFill',
  'BIconBuilding',
  'BIconBullseye',
  'BIconCalendar',
  'BIconCalendarFill',
  'BIconCamera',
  'BIconCameraVideo',
  'BIconCameraVideoFill',
  'BIconCapslock',
  'BIconCapslockFill',
  'BIconChat',
  'BIconChatFill',
  'BIconCheck',
  'BIconCheckBox',
  'BIconCheckCircle',
  'BIconChevronCompactDown',
  'BIconChevronCompactLeft',
  'BIconChevronCompactRight',
  'BIconChevronCompactUp',
  'BIconChevronDown',
  'BIconChevronLeft',
  'BIconChevronRight',
  'BIconChevronUp',
  'BIconCircle',
  'BIconCircleFill',
  'BIconCircleHalf',
  'BIconCircleSlash',
  'BIconClock',
  'BIconClockFill',
  'BIconCloud',
  'BIconCloudDownload',
  'BIconCloudFill',
  'BIconCloudUpload',
  'BIconCode',
  'BIconCodeSlash',
  'BIconColumns',
  'BIconColumnsGutters',
  'BIconCommand',
  'BIconCompass',
  'BIconCone',
  'BIconConeStriped',
  'BIconController',
  'BIconCreditCard',
  'BIconCursor',
  'BIconCursorFill',
  'BIconDash',
  'BIconDiamond',
  'BIconDiamondHalf',
  'BIconDisplay',
  'BIconDisplayFill',
  'BIconDocument',
  'BIconDocumentCode',
  'BIconDocumentDiff',
  'BIconDocumentRichtext',
  'BIconDocumentSpreadsheet',
  'BIconDocumentText',
  'BIconDocuments',
  'BIconDocumentsAlt',
  'BIconDot',
  'BIconDownload',
  'BIconEggFried',
  'BIconEject',
  'BIconEjectFill',
  'BIconEnvelope',
  'BIconEnvelopeFill',
  'BIconEnvelopeOpen',
  'BIconEnvelopeOpenFill',
  'BIconEye',
  'BIconEyeFill',
  'BIconEyeSlash',
  'BIconEyeSlashFill',
  'BIconFilter',
  'BIconFlag',
  'BIconFlagFill',
  'BIconFolder',
  'BIconFolderFill',
  'BIconFolderSymlink',
  'BIconFolderSymlinkFill',
  'BIconFonts',
  'BIconForward',
  'BIconForwardFill',
  'BIconGear',
  'BIconGearFill',
  'BIconGearWide',
  'BIconGearWideConnected',
  'BIconGeo',
  'BIconGraphDown',
  'BIconGraphUp',
  'BIconGrid',
  'BIconGridFill',
  'BIconHammer',
  'BIconHash',
  'BIconHeart',
  'BIconHeartFill',
  'BIconHouse',
  'BIconHouseFill',
  'BIconImage',
  'BIconImageAlt',
  'BIconImageFill',
  'BIconImages',
  'BIconInbox',
  'BIconInboxFill',
  'BIconInboxes',
  'BIconInboxesFill',
  'BIconInfo',
  'BIconInfoFill',
  'BIconInfoSquare',
  'BIconInfoSquareFill',
  'BIconJustify',
  'BIconJustifyLeft',
  'BIconJustifyRight',
  'BIconKanban',
  'BIconKanbanFill',
  'BIconLaptop',
  'BIconLayoutSidebar',
  'BIconLayoutSidebarReverse',
  'BIconLayoutSplit',
  'BIconList',
  'BIconListCheck',
  'BIconListOl',
  'BIconListTask',
  'BIconListUl',
  'BIconLock',
  'BIconLockFill',
  'BIconMap',
  'BIconMic',
  'BIconMoon',
  'BIconMusicPlayer',
  'BIconMusicPlayerFill',
  'BIconOption',
  'BIconOutlet',
  'BIconPause',
  'BIconPauseFill',
  'BIconPen',
  'BIconPencil',
  'BIconPeople',
  'BIconPeopleFill',
  'BIconPerson',
  'BIconPersonFill',
  'BIconPhone',
  'BIconPhoneLandscape',
  'BIconPieChart',
  'BIconPieChartFill',
  'BIconPlay',
  'BIconPlayFill',
  'BIconPlug',
  'BIconPlus',
  'BIconPower',
  'BIconQuestion',
  'BIconQuestionFill',
  'BIconQuestionSquare',
  'BIconQuestionSquareFill',
  'BIconReply',
  'BIconReplyAll',
  'BIconReplyAllFill',
  'BIconReplyFill',
  'BIconScrewdriver',
  'BIconSearch',
  'BIconShield',
  'BIconShieldFill',
  'BIconShieldLock',
  'BIconShieldLockFill',
  'BIconShieldShaded',
  'BIconShift',
  'BIconShiftFill',
  'BIconSkipBackward',
  'BIconSkipBackwardFill',
  'BIconSkipEnd',
  'BIconSkipEndFill',
  'BIconSkipForward',
  'BIconSkipForwardFill',
  'BIconSkipStart',
  'BIconSkipStartFill',
  'BIconSpeaker',
  'BIconSquare',
  'BIconSquareFill',
  'BIconSquareHalf',
  'BIconStar',
  'BIconStarFill',
  'BIconStarHalf',
  'BIconStop',
  'BIconStopFill',
  'BIconStopwatch',
  'BIconStopwatchFill',
  'BIconSun',
  'BIconTable',
  'BIconTablet',
  'BIconTabletLandscape',
  'BIconTag',
  'BIconTagFill',
  'BIconTerminal',
  'BIconTerminalFill',
  'BIconTextCenter',
  'BIconTextIndentLeft',
  'BIconTextIndentRight',
  'BIconTextLeft',
  'BIconTextRight',
  'BIconThreeDots',
  'BIconThreeDotsVertical',
  'BIconToggleOff',
  'BIconToggleOn',
  'BIconToggles',
  'BIconTools',
  'BIconTrash',
  'BIconTrashFill',
  'BIconTriangle',
  'BIconTriangleFill',
  'BIconTriangleHalf',
  'BIconTrophy',
  'BIconTv',
  'BIconTvFill',
  'BIconType',
  'BIconTypeBold',
  'BIconTypeH1',
  'BIconTypeH2',
  'BIconTypeH3',
  'BIconTypeItalic',
  'BIconTypeStrikethrough',
  'BIconTypeUnderline',
  'BIconUnlock',
  'BIconUnlockFill',
  'BIconUpload',
  'BIconVolumeDown',
  'BIconVolumeDownFill',
  'BIconVolumeMute',
  'BIconVolumeMuteFill',
  'BIconVolumeUp',
  'BIconVolumeUpFill',
  'BIconWallet',
  'BIconWatch',
  'BIconWifi',
  'BIconWindow',
  'BIconWrench',
  'BIconX',
  'BIconXCircle',
  'BIconXCircleFill',
  'BIconXOctagon',
  'BIconXOctagonFill',
  'BIconXSquare',
  'BIconXSquareFill'
]

// Export the icons plugin
export const IconsPlugin = /*#__PURE__*/ pluginFactoryNoConfig({
  components: {
    // Icon helper component
    BIcon,
    // Icon stacking component
    BIconstack,
    // BootstrapVue custom icon components
    BIconBlank,
    // Bootstrap icon components
    BIconAlarm,
    BIconAlarmFill,
    BIconAlertCircle,
    BIconAlertCircleFill,
    BIconAlertOctagon,
    BIconAlertOctagonFill,
    BIconAlertSquare,
    BIconAlertSquareFill,
    BIconAlertTriangle,
    BIconAlertTriangleFill,
    BIconArchive,
    BIconArchiveFill,
    BIconArrowBarBottom,
    BIconArrowBarLeft,
    BIconArrowBarRight,
    BIconArrowBarUp,
    BIconArrowClockwise,
    BIconArrowCounterclockwise,
    BIconArrowDown,
    BIconArrowDownLeft,
    BIconArrowDownRight,
    BIconArrowDownShort,
    BIconArrowLeft,
    BIconArrowLeftRight,
    BIconArrowLeftShort,
    BIconArrowRepeat,
    BIconArrowRight,
    BIconArrowRightShort,
    BIconArrowUp,
    BIconArrowUpDown,
    BIconArrowUpLeft,
    BIconArrowUpRight,
    BIconArrowUpShort,
    BIconArrowsAngleContract,
    BIconArrowsAngleExpand,
    BIconArrowsCollapse,
    BIconArrowsExpand,
    BIconArrowsFullscreen,
    BIconAt,
    BIconAward,
    BIconBackspace,
    BIconBackspaceFill,
    BIconBackspaceReverse,
    BIconBackspaceReverseFill,
    BIconBarChart,
    BIconBarChartFill,
    BIconBattery,
    BIconBatteryCharging,
    BIconBatteryFull,
    BIconBell,
    BIconBellFill,
    BIconBlockquoteLeft,
    BIconBlockquoteRight,
    BIconBook,
    BIconBookHalfFill,
    BIconBookmark,
    BIconBookmarkFill,
    BIconBootstrap,
    BIconBootstrapFill,
    BIconBootstrapReboot,
    BIconBoxArrowBottomLeft,
    BIconBoxArrowBottomRight,
    BIconBoxArrowDown,
    BIconBoxArrowLeft,
    BIconBoxArrowRight,
    BIconBoxArrowUp,
    BIconBoxArrowUpLeft,
    BIconBoxArrowUpRight,
    BIconBraces,
    BIconBrightnessFillHigh,
    BIconBrightnessFillLow,
    BIconBrightnessHigh,
    BIconBrightnessLow,
    BIconBrush,
    BIconBucket,
    BIconBucketFill,
    BIconBuilding,
    BIconBullseye,
    BIconCalendar,
    BIconCalendarFill,
    BIconCamera,
    BIconCameraVideo,
    BIconCameraVideoFill,
    BIconCapslock,
    BIconCapslockFill,
    BIconChat,
    BIconChatFill,
    BIconCheck,
    BIconCheckBox,
    BIconCheckCircle,
    BIconChevronCompactDown,
    BIconChevronCompactLeft,
    BIconChevronCompactRight,
    BIconChevronCompactUp,
    BIconChevronDown,
    BIconChevronLeft,
    BIconChevronRight,
    BIconChevronUp,
    BIconCircle,
    BIconCircleFill,
    BIconCircleHalf,
    BIconCircleSlash,
    BIconClock,
    BIconClockFill,
    BIconCloud,
    BIconCloudDownload,
    BIconCloudFill,
    BIconCloudUpload,
    BIconCode,
    BIconCodeSlash,
    BIconColumns,
    BIconColumnsGutters,
    BIconCommand,
    BIconCompass,
    BIconCone,
    BIconConeStriped,
    BIconController,
    BIconCreditCard,
    BIconCursor,
    BIconCursorFill,
    BIconDash,
    BIconDiamond,
    BIconDiamondHalf,
    BIconDisplay,
    BIconDisplayFill,
    BIconDocument,
    BIconDocumentCode,
    BIconDocumentDiff,
    BIconDocumentRichtext,
    BIconDocumentSpreadsheet,
    BIconDocumentText,
    BIconDocuments,
    BIconDocumentsAlt,
    BIconDot,
    BIconDownload,
    BIconEggFried,
    BIconEject,
    BIconEjectFill,
    BIconEnvelope,
    BIconEnvelopeFill,
    BIconEnvelopeOpen,
    BIconEnvelopeOpenFill,
    BIconEye,
    BIconEyeFill,
    BIconEyeSlash,
    BIconEyeSlashFill,
    BIconFilter,
    BIconFlag,
    BIconFlagFill,
    BIconFolder,
    BIconFolderFill,
    BIconFolderSymlink,
    BIconFolderSymlinkFill,
    BIconFonts,
    BIconForward,
    BIconForwardFill,
    BIconGear,
    BIconGearFill,
    BIconGearWide,
    BIconGearWideConnected,
    BIconGeo,
    BIconGraphDown,
    BIconGraphUp,
    BIconGrid,
    BIconGridFill,
    BIconHammer,
    BIconHash,
    BIconHeart,
    BIconHeartFill,
    BIconHouse,
    BIconHouseFill,
    BIconImage,
    BIconImageAlt,
    BIconImageFill,
    BIconImages,
    BIconInbox,
    BIconInboxFill,
    BIconInboxes,
    BIconInboxesFill,
    BIconInfo,
    BIconInfoFill,
    BIconInfoSquare,
    BIconInfoSquareFill,
    BIconJustify,
    BIconJustifyLeft,
    BIconJustifyRight,
    BIconKanban,
    BIconKanbanFill,
    BIconLaptop,
    BIconLayoutSidebar,
    BIconLayoutSidebarReverse,
    BIconLayoutSplit,
    BIconList,
    BIconListCheck,
    BIconListOl,
    BIconListTask,
    BIconListUl,
    BIconLock,
    BIconLockFill,
    BIconMap,
    BIconMic,
    BIconMoon,
    BIconMusicPlayer,
    BIconMusicPlayerFill,
    BIconOption,
    BIconOutlet,
    BIconPause,
    BIconPauseFill,
    BIconPen,
    BIconPencil,
    BIconPeople,
    BIconPeopleFill,
    BIconPerson,
    BIconPersonFill,
    BIconPhone,
    BIconPhoneLandscape,
    BIconPieChart,
    BIconPieChartFill,
    BIconPlay,
    BIconPlayFill,
    BIconPlug,
    BIconPlus,
    BIconPower,
    BIconQuestion,
    BIconQuestionFill,
    BIconQuestionSquare,
    BIconQuestionSquareFill,
    BIconReply,
    BIconReplyAll,
    BIconReplyAllFill,
    BIconReplyFill,
    BIconScrewdriver,
    BIconSearch,
    BIconShield,
    BIconShieldFill,
    BIconShieldLock,
    BIconShieldLockFill,
    BIconShieldShaded,
    BIconShift,
    BIconShiftFill,
    BIconSkipBackward,
    BIconSkipBackwardFill,
    BIconSkipEnd,
    BIconSkipEndFill,
    BIconSkipForward,
    BIconSkipForwardFill,
    BIconSkipStart,
    BIconSkipStartFill,
    BIconSpeaker,
    BIconSquare,
    BIconSquareFill,
    BIconSquareHalf,
    BIconStar,
    BIconStarFill,
    BIconStarHalf,
    BIconStop,
    BIconStopFill,
    BIconStopwatch,
    BIconStopwatchFill,
    BIconSun,
    BIconTable,
    BIconTablet,
    BIconTabletLandscape,
    BIconTag,
    BIconTagFill,
    BIconTerminal,
    BIconTerminalFill,
    BIconTextCenter,
    BIconTextIndentLeft,
    BIconTextIndentRight,
    BIconTextLeft,
    BIconTextRight,
    BIconThreeDots,
    BIconThreeDotsVertical,
    BIconToggleOff,
    BIconToggleOn,
    BIconToggles,
    BIconTools,
    BIconTrash,
    BIconTrashFill,
    BIconTriangle,
    BIconTriangleFill,
    BIconTriangleHalf,
    BIconTrophy,
    BIconTv,
    BIconTvFill,
    BIconType,
    BIconTypeBold,
    BIconTypeH1,
    BIconTypeH2,
    BIconTypeH3,
    BIconTypeItalic,
    BIconTypeStrikethrough,
    BIconTypeUnderline,
    BIconUnlock,
    BIconUnlockFill,
    BIconUpload,
    BIconVolumeDown,
    BIconVolumeDownFill,
    BIconVolumeMute,
    BIconVolumeMuteFill,
    BIconVolumeUp,
    BIconVolumeUpFill,
    BIconWallet,
    BIconWatch,
    BIconWifi,
    BIconWindow,
    BIconWrench,
    BIconX,
    BIconXCircle,
    BIconXCircleFill,
    BIconXOctagon,
    BIconXOctagonFill,
    BIconXSquare,
    BIconXSquareFill
  }
})

// Export the BootstrapVueIcons plugin installer
// Mainly for the stand-alone bootstrap-vue-icons.xxx.js builds
export const BootstrapVueIcons = /*#__PURE__*/ pluginFactoryNoConfig(
  { plugins: { IconsPlugin } },
  { NAME: 'BootstrapVueIcons' }
)

// --- END AUTO-GENERATED FILE ---
